import {
  CATEGORIES_CREATE_CATEGORY,
  CATEGORIES_FETCH_ALL_CATEGORIES_CATALOG,
  CATEGORIES_FETCH_CATEGORIES,
  CATEGORIES_FETCH_CATEGORIES_BY_NAME,
  CATEGORIES_FETCH_CATEGORIES_CATALOG,
  CATEGORIES_SET_PAGE,
  CATEGORIES_SET_ROWS_PER_PAGE,
  CATEGORY_CLEAR_PAGINATION_INFO
} from "../action-types/categories-types";
import AppConstants from "../../AppConstants";

const initialState = {
  entities: [],
  entitiesCatalog: [],
  entitiesFilter: [],
  entity: {},
  entityLoaded: false,
  loading: false,
  paginationConfig: {
    total: 0,
    page: 1,
    rowsPerPage: AppConstants.rowsPerPage,
  },
};

export default function (state = initialState, action) {
  const payloadData = action?.payload?.data?.pagination
    ? action?.payload?.data?.categories
    : action?.payload?.data;
  switch (action.type) {
    case CATEGORIES_FETCH_CATEGORIES.REQUEST:
    case CATEGORIES_FETCH_CATEGORIES_CATALOG.REQUEST:
    case CATEGORIES_CREATE_CATEGORY.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CATEGORIES_FETCH_ALL_CATEGORIES_CATALOG.REQUEST:
      return {
        ...state,
        loading: true,
        entitiesCatalog: [],
      };
    case CATEGORIES_FETCH_ALL_CATEGORIES_CATALOG.SUCCESS:
      return {
        ...state,
        loading: false,
        entitiesCatalog: [
          ...state.entitiesCatalog.filter(entity => entity),
          ...payloadData,
        ],
      };
    case CATEGORIES_FETCH_CATEGORIES.SUCCESS:
      return {
        ...state,
        entities: [...payloadData],
        loading: false,
        paginationConfig: {
          ...state.paginationConfig,
          total:
            action.payload.data?.pagination?.total ||
            state.paginationConfig.total,
        },
      };
    case CATEGORIES_FETCH_CATEGORIES_BY_NAME.SUCCESS:
      return {
        ...state,
        entitiesFilter: [...action.payload.data],
        loading: false,
      };
    case CATEGORIES_FETCH_CATEGORIES_CATALOG.SUCCESS:
      return {
        ...state,
        entitiesCatalog: [...action.payload.data.categories],
        loading: false,
        paginationConfig: {
          ...state.paginationConfig,
          total: action.payload.data.pagination.total,
        },
      };
    case CATEGORIES_SET_ROWS_PER_PAGE:
      return {
        ...state,
        paginationConfig: {
          ...state.paginationConfig,
          rowsPerPage: action.payload,
        },
      };
    case CATEGORIES_SET_PAGE:
      return {
        ...state,
        paginationConfig: {
          ...state.paginationConfig,
          page: action.payload,
        },
      };
      case CATEGORY_CLEAR_PAGINATION_INFO:
        return {
          ...state,
          paginationConfig: {
            page: 1,
            rowsPerPage: AppConstants.rowsPerPage,
            total: 0,
          },
        };
    case CATEGORIES_FETCH_CATEGORIES.REJECTED:
      return {
        ...state,
        loading: false,
        entities: [],
      };
    case CATEGORIES_CREATE_CATEGORY.REJECTED:
    case CATEGORIES_CREATE_CATEGORY.SUCCESS:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
}
